import { combineEpics } from 'redux-observable';
import { BehaviorSubject } from 'rxjs';
import { RootEpic } from './app.epics.type';
import { mergeMap } from 'rxjs/operators';

export const epic$ = new BehaviorSubject(combineEpics(...([] as RootEpic[])));

export const rootEpic: RootEpic = (action$, state$, dependencies) =>
  epic$.pipe(mergeMap((epic) => epic(action$, state$, dependencies)));
